import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import BusinessHero from "../components/BusinessHero";
import ContactForm from "../components/ContactForm";
import "../styles/services-pages.css";

const businessServices = [
  {
    id: "01",
    title: {
      en: "Commercial & Business Strategy Development",
      ar: "تطوير الاستراتيجية التجارية واستراتيجية تطوير الأعمال",
    },
    points: {
      en: [
        "Business Development Strategy",
        "Growth & expansion strategy",
        "Go-To-Market (local & international)",
        "Strategic partnerships & alliances",
        "New business models & products",
      ],
      ar: [
        "استراتيجية تطوير الأعمال",
        "استراتيجية النمو والتوسع",
        "استراتيجية الدخول إلى السوق (محليًا ودوليًا)",
        "الشراكات والتحالفات الاستراتيجية",
        "نماذج أعمال ومنتجات جديدة",
      ],
    },
  },
  {
    id: "02",
    title: {
      en: "Market & Commercial Analysis",
      ar: "تحليل السوق والتحليل التجاري",
    },
    points: {
      en: [
        "Market & sector analysis",
        "Competitive landscape analysis",
        "Investment opportunities assessment",
        "Segmentation & target audience",
        "Supply & demand analysis + market testing",
      ],
      ar: [
        "تحليل السوق والقطاع",
        "تحليل المشهد التنافسي",
        "تقييم فرص الاستثمار",
        "تقسيم الشرائح وتحديد الجمهور المستهدف",
        "تحليل العرض والطلب + اختبار السوق",
      ],
    },
  },
  {
    id: "03",
    title: {
      en: "Partnerships & Alliances Development",
      ar: "تطوير الشراكات والتحالفات",
    },
    points: {
      en: [
        "Find local & international partners",
        "Alliance building plans",
        "Negotiation & agreement success",
        "Pitch decks for investors/partners",
      ],
      ar: [
        "البحث عن شركاء محليين ودوليين",
        "إعداد خطط بناء التحالفات",
        "التفاوض وإتمام الاتفاقيات بنجاح",
        "إعداد عروض تقديمية للمستثمرين/الشركاء",
      ],
    },
  },
  {
    id: "04",
    title: {
      en: "Sales Enablement & Value Propositions",
      ar: "تمكين المبيعات وبناء عروض القيمة",
    },
    points: {
      en: [
        "Value proposition development",
        "Sales strategy & incentives",
        "Customer journey & experience improvement",
        "New channels (B2B/B2G/B2C)",
        "Sales process review & optimization",
      ],
      ar: [
        "تطوير عرض القيمة (Value Proposition)",
        "استراتيجية المبيعات والحوافز",
        "تحسين رحلة العميل وتجربة العملاء",
        "تطوير قنوات جديدة (B2B/B2G/B2C)",
        "مراجعة عملية المبيعات وتحسينها",
      ],
    },
  },
  {
    id: "05",
    title: {
      en: "Relationship & Channel Development",
      ar: "تطوير العلاقات وقنوات البيع",
    },
    points: {
      en: [
        "Key account management",
        "Distribution & sales channels development",
        "Build business networks",
        "Government & regulatory engagement (as needed)",
      ],
      ar: [
        "إدارة الحسابات الرئيسية (Key Accounts)",
        "تطوير قنوات التوزيع والبيع",
        "بناء شبكات وعلاقات الأعمال",
        "التواصل مع الجهات الحكومية والتنظيمية (عند الحاجة)",
      ],
    },
  },
  {
    id: "06",
    title: {
      en: "Product & Service Development",
      ar: "تطوير المنتجات والخدمات",
    },
    points: {
      en: [
        "Customer needs analysis & new products",
        "Innovative services & solutions design",
        "Data-driven testing & improvements",
        "Pricing models design",
      ],
      ar: [
        "تحليل احتياجات العملاء وتطوير منتجات جديدة",
        "تصميم خدمات وحلول مبتكرة",
        "اختبار وتحسينات مبنية على البيانات",
        "تصميم نماذج التسعير",
      ],
    },
  },
  {
    id: "07",
    title: {
      en: "Brand & Positioning Development",
      ar: "تطوير العلامة التجارية والتموضع",
    },
    points: {
      en: [
        "Market positioning",
        "Brand equity & reputation",
        "Visual identity & commercial messaging",
        "Go-to-market reach campaigns",
      ],
      ar: [
        "التموضع في السوق (Market Positioning)",
        "قيمة العلامة التجارية والسمعة",
        "الهوية البصرية والرسائل التجارية",
        "حملات الوصول عند الدخول إلى السوق",
      ],
    },
  },
  {
    id: "08",
    title: {
      en: "Commercial & Operational Planning",
      ar: "التخطيط التجاري والتشغيلي",
    },
    points: {
      en: [
        "Annual commercial plans",
        "Operating plans aligned with sales & BD",
        "KPIs for business teams",
        "Performance tracking & reporting mechanisms",
      ],
      ar: [
        "خطط تجارية سنوية",
        "خطط تشغيل متوافقة مع المبيعات وتطوير الأعمال",
        "مؤشرات أداء (KPIs) لفرق الأعمال",
        "آليات متابعة الأداء وإعداد التقارير",
      ],
    },
  },
  {
    id: "09",
    title: {
      en: "Business Documentation Services",
      ar: "خدمات إعداد وثائق الأعمال",
    },
    points: {
      en: [
        "Professional pitch decks",
        "Company profiles & capability statements",
        "Partnership letters & alliance docs",
        "RFP responses & proposals",
      ],
      ar: [
        "عروض تقديمية احترافية (Pitch Decks)",
        "بروفايل الشركة وبيانات القدرات (Capability Statements)",
        "خطابات الشراكة ووثائق التحالفات",
        "الردود على طلبات العروض (RFP) وإعداد المقترحات",
      ],
    },
  },
  {
    id: "10",
    title: {
      en: "Investment & Funding Readiness",
      ar: "الجاهزية للاستثمار والتمويل",
    },
    points: {
      en: [
        "Investor decks",
        "Financial growth & profit plans",
        "Connect with local & global investors",
        "Funding readiness analysis",
      ],
      ar: [
        "عروض تقديمية للمستثمرين (Investor Decks)",
        "خطط النمو المالي وخطط الربحية",
        "ربط مع مستثمرين محليين وعالميين",
        "تحليل جاهزية التمويل",
      ],
    },
  },
];

function BusinessPage() {
  const [language, setLanguage] = useState("en");
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("lang");
    if (saved === "en" || saved === "ar") setLanguage(saved);
  }, []);

  useEffect(() => {
    localStorage.setItem("lang", language);
  }, [language]);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleLanguage = () =>
    setLanguage((prev) => (prev === "en" ? "ar" : "en"));

  return (
    <div className="app" lang={language} dir="ltr">
      <Header
        language={language}
        toggleLanguage={toggleLanguage}
        isScrolled={isScrolled}
      />

      <BusinessHero language={language} />

      <section className="service-detail-section">
        <h2 className="detail-title">
          {language === "en"
            ? "Business Development & Commercial Services"
            : "Business Development & Commercial Services"}
        </h2>

        <p className="detail-desc">
          {language === "en"
            ? "A structured set of commercial and business development services covering strategy, market analysis, partnerships, sales enablement, branding, planning, documentation, and funding readiness."
            : "A structured set of commercial and business development services covering strategy, market analysis, partnerships, sales enablement, branding, planning, documentation, and funding readiness."}
        </p>

        <div className="detail-grid">
          {businessServices.map((service) => (
            <div key={service.id} className="detail-card">
              <div className="detail-icon">{service.id}</div>
              <h3>{service.title[language]}</h3>
              <ul>
                {service.points[language].map((p, idx) => (
                  <li key={`${service.id}-${idx}`}>{p}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      <div id="contact" />
      <ContactForm language={language} />
    </div>
  );
}

export default BusinessPage;